<template>
  <div class="callScreen-main">
    <div class="callScreen-title">
      <div class="title-left"><i class="wk wk-health-station"></i>天津市空港湖滨社区卫生服务中心</div>
      <div class="title-right">{{ currentTime }}</div>
    </div>
    <div class="callScreen-list">
      <div class="list-while list-left">
        <div class="list-item item-title">
          <div class="content content1">序号</div>
          <div class="content content2">姓名</div>
          <div class="content content3">随访</div>
          <div class="content content4">签约</div>
          <div class="content content5">内容</div>
        </div>
        <div class="list-item" v-for="item in list">
          <div class="content content1">{{item.serialNumber}}</div>
          <div class="content content2">{{item.sickName}}</div>
          <div class="content content3">{{item.followContent}}</div>
          <div class="content content4">{{item.signContent}}</div>
          <div class="content content5">{{item.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        list: [
          {'serialNumber': '', 'sickName': '', 'content': '', 'followContent': '', 'signContent': '', 'examineContent': ''},
          {'serialNumber': '', 'sickName': '', 'content': '', 'followContent': '', 'signContent': '', 'examineContent': ''},
          {'serialNumber': '', 'sickName': '', 'content': '', 'followContent': '', 'signContent': '', 'examineContent': ''},
          {'serialNumber': '', 'sickName': '', 'content': '', 'followContent': '', 'signContent': '', 'examineContent': ''},
          {'serialNumber': '', 'sickName': '', 'content': '', 'followContent': '', 'signContent': '', 'examineContent': ''}
        ],
        currentTime: this.getNowTime() // 初始时间
      };
    },
    created() {
      this.updateTime(); // 页面加载后立即更新时间
      setInterval(() => {this.updateTime();},1000);// 每秒钟更新一次时间
      this.getData();
      setInterval(() => {this.getData();},1000); // 每秒钟更新一次时间
    },
    methods: {
      //获取数据
      getData(){
        return this.request({
          method:'post',
          url:'/register/getCallScreenInfo',
          params:{}
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.list = response.data.list;
        })
      },
      updateTime() {
        this.currentTime = this.getNowTime()
      },
      getNowTime(){
        const currentDate = new Date();
        const dayOfWeek = currentDate.getDay();
        // 将数字转换为星期几的文本表示形式
        const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        const currentDayOfWeek = weekdays[dayOfWeek];
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        const seconds = String(currentDate.getSeconds()).padStart(2, '0');
        return `${year}年${month}月${day}日 ${currentDayOfWeek} ${hours}:${minutes}:${seconds}`;
      }
    }
  }
</script>

<style scoped>
  .callScreen-main{height: 100%;color: #fff;}
  .callScreen-title{background-color: #194769;height: 20%;overflow: hidden; padding: 0px 20px;}
  .title-left{float: left; height: 100%; font-size: 4vw; display: flex; align-items: center;}
  .title-left i{font-size: 5vw;margin-right: 4px;}
  .title-right{float: right; height: 100%; font-size: 2vw; display: flex; align-items: center;}

  .callScreen-list{overflow: hidden; height: 80%; padding: 0px 2px;}
  .callScreen-list .list-while{float: left;width: 100%;height: 100%;}
  .callScreen-list .list-while .list-item{height: 16%; margin: 4px 2px; overflow: hidden; padding: 0px 15px;font-size: 3vw; display: flex; align-items: center;}
  .callScreen-list .list-while .list-item:nth-child(odd) {background-color: #0b84b4;}
  .callScreen-list .list-while .list-item:nth-child(even) {background-color: #0467c8;}
  .callScreen-list .list-while .list-item .content{float: left;height: 100%;width: 100%;display: flex;align-items: center;}
  .callScreen-list .list-while .list-item .content:not(:last-child){border-right: 4px solid #fff}
  .callScreen-list .list-while .list-item .content1{width: 350px;justify-content: center;}
  .callScreen-list .list-while .list-item .content2{width: 450px;padding: 0px 5px;}
  .callScreen-list .list-while .list-item.item-title .content2{justify-content: center;}
  .callScreen-list .list-while .list-item .content3{padding: 0px 5px;}
  .callScreen-list .list-while .list-item.item-title .content3{justify-content: center;}
  .callScreen-list .list-while .list-item .content4{width: 650px;padding: 0px 5px;}
  .callScreen-list .list-while .list-item.item-title .content4{justify-content: center;}
  .callScreen-list .list-while .list-item .content5{width: 650px;padding: 0px 5px;}
  .callScreen-list .list-while .list-item.item-title .content5{justify-content: center;}
</style>



// WEBPACK FOOTER //
// src/views/web/callScreen/index.vue